import React from 'react'
import ContactForm from '../ContactFrom/ContactForm'
import icon2 from '../../images/icons/icon_calling_2.svg'
import icon3 from '../../images/icons/icon_mail_3.svg'
import icon4 from '../../images/icons/icon_calendar_2.svg'


const ContactSection = (props) => {
    return (
        <section className="contact_section section_space bg-light">
            <div className="container">
                <div className="contact_info_box row">
                    {/*<div className="col-lg-3 col-md-6 col-sm-6">*/}
                    {/*    <div className="iconbox_block text-center">*/}
                    {/*        <div className="iconbox_icon">*/}
                    {/*            <img src={icon1} alt="Map Mark SVG Icon" />*/}
                    {/*        </div>*/}
                    {/*        <div className="iconbox_content">*/}
                    {/*            <h3 className="iconbox_title">Location</h3>*/}
                    {/*            <p className="mb-0">*/}
                    {/*                Sunshine Business Park Sector-94, Poland*/}
                    {/*            </p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon2} alt="Calling SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Contact</h3>
                                <p className="mb-0"><a href="tel:+31627468033">+31 6 27 46 80 33</a></p>
                                <p className="mb-0"><a href="tel:+31622846624">+31 6 22 84 66 24</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon3} alt="User Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Email</h3>
                                <p className="mb-0"><a href="mailto:info@praeventor.nl">info@praeventor.nl</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="iconbox_block text-center">
                            <div className="iconbox_icon">
                                <img src={icon4} alt="Calendar SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Wij zijn beschikbaar tussen</h3>
                                <p className="mb-0">Mon - Sat: 8.00-17:00</p>
                                <p className="mb-0">Sunday: Gesloten</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section_space pb-0">
                    <div className="row justify-content-lg-between">
                        <div className="col-lg-5">
                            <div>
                                <h3 className="details_item_info_title mb-1">Neem Contact op</h3>
                                <p className="mb-5">
                                    Heeft u vragen of wilt u meer weten over hoe Praeventor uw bedrijf beter kunt beveiligen?
                                    Wij staan voor u klaar, dus neem gerust contact op. We horen graag van u.
                                </p>
                            </div>
                            <div style={{ marginTop: "75px"}}>
                                <h4>Praeventor</h4>
                                <span>Meaning: To come before</span>
                            </div>
                            <div style={{ marginTop: "25px"}}>
                                <p><a href="mailto:info@praeventor.nl">info@praeventor.nl</a></p>
                                <p><a href="tel:+31627468033">+31 6 27 46 80 33</a></p>
                            </div>
                            {/*<div style={{ marginTop: "50px"}}>*/}

                            {/*    <p>KVK Nummer</p>*/}
                            {/*    <p>BTW-nr </p>*/}
                            {/*</div>*/}

                            {/*<div className="gmap_canvas ps-lg-5">*/}
                            {/*    <iframe title='map' src="https://maps.google.com/maps?q=2880%20Broadway,%20New%20York&t=&z=13&ie=UTF8&iwloc=&output=embed"></iframe>*/}
                            {/*</div>*/}
                        </div>
                        <div className="col-lg-7">
                            <div className="contact_form mb-0">
                                <ContactForm />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;